<template>
  <div
    class="navbar-window"
    id="navbar-user-window"
    :style="{ top: top, right: right, bottom: bottom, left: left }"
  >
    <!-- <div class="user-window-header">
      <div>
        <div class="name text-limited">{{ name }}</div>
        <div class="company text-limited">{{ company }}</div>
        <v-btn
          v-if="!isSuperAdmin"
          class="view-profile-button"
          @click="goToUserPage"
          color="accent"
          :disabled="
            !(
              userHasModulePermission('module_system_management') &&
              userHasManagementPermission('user_show')
            )
          "
        >
          {{ $t("Profile") }}
        </v-btn>
      </div>
    </div> -->

    <div v-if="loading" style="height: 50px; position: relative">
      <loading-spinner
        :active.sync="loading"
        :is-full-page="false"
        color="#4fa2b7"
        :height="25"
      />
    </div>

    <div class="options-container" v-else>
      <a class="options" href="/settings/profile">
        {{ $t("Settings") }}
      </a>

      <settings-menu
        v-if="settingsOpen"
        :two-factor-authentication-pop-up="twoFactorAuthenticationPopUp"
      />

      <div
        v-if="!settingsOpen && !companyButtonDisable"
        class="options"
        @click="changeCompany"
      >
        {{ $t("SwitchCompany") }}
      </div>
      <div v-if="!settingsOpen" class="options" @click="goToWiki">
        {{ $t("Wiki") }}
      </div>
      <div v-if="!settingsOpen" class="options" @click="showLicenses">
        {{ $t("About") }}
      </div>

      <hr v-if="!settingsOpen" id="userHR" />

      <div v-if="!settingsOpen" class="options logout-text" @click="logout">
        {{ $t("Logout") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import SettingsMenu from "./SettingsMenu";
import LoadingSpinner from "vue-loading-overlay";
import companies from '../../../../store/modules/companies';

export default {
  name: "UserWindow",

  components: {
    SettingsMenu,
    LoadingSpinner
  },

  props: {
    top: {
      type: String
    },
    right: {
      type: String
    },
    bottom: {
      type: String
    },
    left: {
      type: String
    },

    /**
     * Determines if, when starting the dialogbox, activate 2fa] and open
     */
    twoFactorAuthenticationPopUp: {
      type: Boolean,
      default: false
    }
  },

  mixins: [checkPermissionsMixin],

  data() {
    return {
      settingsOpen: false,
      companyButtonDisable: true,
      loading: false,
      url: ""
    };
  },

  computed: {
    name() {
      return this.$store.getters.currentUserName;
    },

    avatar() {
      return this.$store.getters.currentUserImage;
    },

    company() {
      return localStorage.getItem("company_name");
    },

    companiesData() {
      return this.$store.getters.companies;
    }
  },

  mounted() {
    // this.checkListCompanies();
    this.getWikiUrl();
  },

  methods: {
    ...mapActions(["LOGOUT", "CHANGE_COMPANY", "GET_USER_COMPANIES","getLicense"]),

    logout() {
      this.LOGOUT()
        .then(() => {
          // Redirect to v3-app login page (outside of /backoffice)
          window.location.href = "/login";
        })
        .catch(error => {
          console.error(error);
          // Even if logout fails, redirect to login
          window.location.href = "/login";
        });
    },

    changeCompany() {
      this.CHANGE_COMPANY().then(() => {
        this.$router.push({ name: "login-company" });
      });
    },

    showLicenses() {
      this.$router.push({ name: "software-licenses" });
    },

    checkListCompanies() {
      if (companies) {
        if (this.companiesData.length < 0) {
          if (this.companiesData.length > 1) {
            this.companyButtonDisable = false;
          }
          this.loading = false;
        } else {
          this.GET_USER_COMPANIES()
            .then(resp => {
              if (resp.length > 1) {
                this.companyButtonDisable = false;
              }
            })
            .catch(error => console.error(error))
            .then(() => {
              this.loading = false;
            });
        }
      }
    },
    async getWikiUrl() {
      let license = await this.getLicense();
      this.url = license.data.data.cf_wiki_url;
    },
    goToWiki(){
      window.open(this.url, '_blank');
    }
  }
};
</script>

<style scoped>
.navbar-window {
  position: absolute;
  min-width: 140px;
  z-index: 100;
}
.user-window-header {
  min-width: 210px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
}

.avatar {
  width: 65px;
  height: 65px;
  margin-right: 10px;
  object-fit: cover;
}

.name {
  font-weight: bold;
}

.company {
  font-size: 10px;
  color: #b1b6b9;
}

.view-profile-button {
  width: 80px;
  margin-top: 5px;
  padding: 4px !important;
  height: 30px !important;
  text-align: center;
  font-size: 8px !important;
}

.options-container {
  padding: 10px;
}
.options {
  color: #231E46;
  padding: 10px 10px;
  font-size: 12px;
  cursor: pointer;
}
.options:hover {
  color: #231E46;
}
.options.selected {
  font-weight: bold;
  color: #231E46;
}

.logout-text {
  color: #b1b6b9;
}

.vertical-flex {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.text-limited {
  min-width: 125px;
  max-width: 200px;
  max-height: 35px;
  line-height: normal !important;
  text-overflow: ellipsis;
  overflow: hidden;
}

#userHR {
  width: 90%;
  text-align: center;
  margin: 0 auto;
  background: rgba(35, 30, 70, 0.50);
  height: 1px;
  border: 0;
}

.profile-disabled {
  cursor: default !important;
  color: #b1b6b9 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Navbar/UserWindow/UserWindow.vue